import DOMPurify, { type Config } from 'dompurify'

/**
 * Sanitizes stored agreement HTML and forces every link to open in a new tab.
 *
 * DOMPurify's default allow-list keeps `rel` but drops `target`, so the
 * `target="_blank"` BlockNote writes into the stored HTML never survives to the
 * page. Rather than allow-listing `target` and trusting whatever is stored, set
 * it — and the `rel` that has to accompany it to prevent reverse tabnabbing —
 * on the already-sanitized output.
 */
const sanitizeAgreementHtml = (html: string, config?: Config): string => {
    const clean = DOMPurify.sanitize(html ?? '', config)
    const doc = new DOMParser().parseFromString(clean, 'text/html')

    doc.querySelectorAll('a[href]').forEach(a => {
        a.setAttribute('target', '_blank')
        a.setAttribute('rel', 'noopener noreferrer')
    })

    return doc.body.innerHTML
}

export { sanitizeAgreementHtml }
